import React from 'react';
import { CoreAsmUserTrackingConflict, CoreAsmUserTrackingConflictType } from '../../../../models/CoreTrackingOperation';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface AsmUserTrackingOperationsValidationResultProps {
    asmId?: string
    conflicts: CoreAsmUserTrackingConflict[]
}

const AsmUserTrackingOperationsValidationResult: React.FC<AsmUserTrackingOperationsValidationResultProps> = (props) => {
    const { t } = useTranslation(["common", "schoolAdministration"]);
    const conflictLookup = new Map<CoreAsmUserTrackingConflictType, CoreAsmUserTrackingConflict[]>();

    props.conflicts.forEach((conflict) => {
        const conflicts = conflictLookup.get(conflict.type);
        if (conflicts) {
            conflicts.push(conflict);
        } else {
            conflictLookup.set(conflict.type, [conflict]);
        }
    });

    const getText = (conflictType: CoreAsmUserTrackingConflictType, asmId?: string): string => {
        switch (conflictType) {
            case CoreAsmUserTrackingConflictType.TrackingKey:
                return t("trackingOperations.asm.error.trackingKey", { ns: "schoolAdministration", asmId });
            case CoreAsmUserTrackingConflictType.SourceObjectType:
                return t("trackingOperations.asm.error.sourceObjectType", { ns: "schoolAdministration" });
            case CoreAsmUserTrackingConflictType.Identifier:
                return t("trackingOperations.asm.error.identifier", { ns: "schoolAdministration", asmId });
            default:
                return t("error.somethingWentWrong", { ns: "common" });
        }
    }

    return <>{Array.from(conflictLookup).sort((a, b) => a[0] - b[0]).map((entry) => (<>
        <p>{getText(entry[0], props.asmId)}</p>
        {showUserLinks(entry[0]) && <ul>
            {entry[1].map((conflict) => (<li key={conflict.trackingId}><Link target="_blank" to={`/user/${conflict.flowSyncId}/trackings`}>{conflict.displayName}</Link></li>))}
        </ul>}
    </>))}
    </>;
}



const showUserLinks = (conflictType: CoreAsmUserTrackingConflictType): boolean => {
    switch (conflictType) {
        case CoreAsmUserTrackingConflictType.TrackingKey:
        case CoreAsmUserTrackingConflictType.SourceObjectType:
            return false;
        case CoreAsmUserTrackingConflictType.Identifier:
            return true;
        default:
            return false;
    }
}

export default AsmUserTrackingOperationsValidationResult;
